import React from "react";

interface AccountsTypeElementFieldProps {
  title: string;
  handleClick: () => void;
  className?: string;
}

export const AccountsTypeElementField = ({
  title,
  handleClick,
  className,
}: AccountsTypeElementFieldProps) => {
  return (
    <li>
      <button type="button" onClick={handleClick} className={className}>{title}</button>
    </li>
  );
};
